import { createFileRoute } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { PageToolbar } from '@/components/layout/page-header'
import { InstanceSubnav } from '@/features/instances/components/instance-subnav'
import { DiagnosticResultDetail } from '@/features/diagnostics/components/diagnostic-result-detail'

export const Route = createFileRoute(
  '/_authenticated/instances/$instanceId/diagnostics/$resultId'
)({
  component: DiagnosticResultPage,
})

function DiagnosticResultPage() {
  const { instanceId, resultId } = Route.useParams()
  const numericInstanceId = parseInt(instanceId, 10)
  const numericResultId = parseInt(resultId, 10)

  return (
    <>
      <PageToolbar />

      <Main className='flex flex-1 flex-col gap-4 sm:gap-6'>
        <InstanceSubnav instanceId={instanceId} activeTab='diagnostics' />
        <DiagnosticResultDetail
          instanceId={numericInstanceId}
          resultId={numericResultId}
        />
      </Main>
    </>
  )
}
